// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button___Bojc","content":"GlobalSearch_content__3SZu0"};